import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.188 2.75h-1.375v-.687a.687.687 0 1 0-1.376 0v.687h-2.75v-.687a.687.687 0 1 0-1.374 0v.687h-2.75v-.687a.688.688 0 1 0-1.375 0v.687H4.813a1.377 1.377 0 0 0-1.375 1.375v13.063a2.753 2.753 0 0 0 2.75 2.75h9.625a2.753 2.753 0 0 0 2.75-2.75V4.125a1.376 1.376 0 0 0-1.375-1.375M13.75 14.438h-5.5a.687.687 0 1 1 0-1.375h5.5a.687.687 0 1 1 0 1.375m0-2.75h-5.5a.687.687 0 1 1 0-1.375h5.5a.687.687 0 1 1 0 1.375"
    }, null, -1)
  ])))
}
export default { render: render }